import { useQuery } from '@tanstack/react-query';

import { getCampaigns } from 'apis/restaurant-api/merchant-admin/campaigns/api';

import { CampaignsQueryKeys } from '../campaignsQueryKeys';
import { CampaignStatus } from '../types';

export const useActiveCampaignsCount = ({
  merchantId,
  venueIds,
  enabled,
}: {
  merchantId: string;
  venueIds?: string[];
  enabled: boolean;
}) => {
  const { data, isFetching } = useQuery(
    [
      ...CampaignsQueryKeys.GET_ALL(merchantId, venueIds),
      { page: 1, pageSize: 1, status: [CampaignStatus.SCHEDULED, CampaignStatus.RUNNING], isCreatedByWolt: false },
    ],
    () =>
      getCampaigns({
        merchantId,
        venueIds,
        page: 1,
        pageSize: 1,
        status: [CampaignStatus.SCHEDULED, CampaignStatus.RUNNING],
        isCreatedByWolt: false,
      }),
    {
      refetchOnWindowFocus: false,
      enabled: enabled && !!merchantId,
      retry: false,
    },
  );

  return {
    activeCampaignsCount: data?.document_count,
    isFetching,
  };
};
